<template>
  <ul class="flex flex-col gap-2" data-testid="qualification-missing-list">
    <li
      v-for="reason in missing"
      :key="`${reason.field}-${reason.key}`"
      class="flex flex-wrap items-center justify-between gap-2 rounded-lg border bg-white px-3 py-2"
      :class="isBlocking(reason) ? 'border-negative/40' : 'border-alert/40'"
      :data-testid="`qualification-missing-${reason.field}-${reason.key}`"
    >
      <span class="flex flex-wrap items-center gap-2 text-sm">
        <span class="font-semibold text-textPrimary">{{ catalog.reasonName(reason) }}</span>
        <span
          class="rounded px-1.5 py-0.5 text-xs font-semibold"
          :class="
            reason.status === ProfessionalDocumentStatus.IN_REVIEW
              ? 'bg-primary5 text-primary40'
              : 'bg-red-50 text-negative'
          "
        >
          {{ missingStatusText(reason) }}
        </span>
      </span>
      <LabelBadge
        :label="ON_FAIL_LABEL[reason.onFail]"
        :color="isBlocking(reason) ? 'red' : 'orange'"
        :icon="isBlocking(reason) ? mdiLockOutline : mdiClockOutline"
        size="small"
      />
    </li>
  </ul>
</template>

<script setup lang="ts">
import { mdiClockOutline, mdiLockOutline } from '@mdi/js'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import { useProfessionalDocumentCatalogStore } from '@/pinia-store/useProfessionalDocumentCatalogStore'
import { ProfessionalDocumentStatus } from '@/types/professional-documents.types'
import { QualificationOnFail } from '@/types/qualification-eligibility.types'
import type { EligibilityReason } from '@/types/qualification-eligibility.types'

import { ON_FAIL_LABEL, missingStatusText } from './qualificationText'

defineProps<{ missing: EligibilityReason[] }>()

const isBlocking = (reason: EligibilityReason) => reason.onFail === QualificationOnFail.BLOCK

const catalog = useProfessionalDocumentCatalogStore()
catalog.ensureLoaded().catch(() => {
  // fallback intencional: sem catálogo cada item mostra a própria chave (`reasonName` cai nela),
  // então o item segue visível; o erro fica em `catalog.loadError` (R48.2).
})
</script>
